import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateTeamMemberRole = (orgId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_TEAM_MEMBER_ROLE' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        // const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/org/${orgId}/team`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_TEAM_MEMBER_ROLE_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_TEAM_MEMBER_ROLE_FAILED',
              payload: `Failed to update team member role`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_TEAM_MEMBER_ROLE_FAILED',
            payload: `Failed to update team member role`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_TEAM_MEMBER_ROLE_FAILED',
        payload: `Failed to update team member role`,
      });
    }
  };
};

export default updateTeamMemberRole;
